// TODO 계속 보완 필요

import { IS_CLIENT } from '@repo/common-utils';

interface Data {
  authType?: 'simple-auth' | 'joint-certificate';
  corpType?: 'INDIS' | 'CORPS';
  taxpayerName?: string;
}

export type ResultRefundData = Data | undefined;

const resultRefundDataKey = 'result-refund-data';

export function initResultRefundData() {
  if (IS_CLIENT) {
    sessionStorage.removeItem(resultRefundDataKey);
  }
}

export function getResultRefundData(): ResultRefundData {
  if (IS_CLIENT) {
    const item = sessionStorage.getItem(resultRefundDataKey);
    if (item) {
      return JSON.parse(item);
    }
  }

  return undefined;
}

export function setResultRefundData(data: ResultRefundData) {
  if (IS_CLIENT) {
    sessionStorage.setItem(resultRefundDataKey, JSON.stringify(data));
  }
}

export const CHECK_DECISION_ACTION_CODE_COOKIE_KEY = 'check_decision_action_code';
